import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";

import { Link } from "react-router-dom";
import { Copy } from "react-feather";
import { useSelector } from "react-redux";
import Table2 from '../../core/pagination/datatable2'

// import ViewCustomerOrders from "../../core/modals/usermanagement/viewcustomerorders";
import axios from 'axios';
import { Modal, message } from "antd";

import { dateFormatter2, getCurrencySymbol, getBalanceMessage2 } from "../../plugins/helper";
// import { set } from "date-fns";
const Receivables = () => {
  const [recieved, setRecieved] = useState([]);
//   const [filteredUserRecord, setFilteredUserRecord] = useState([]);
  
  const [allUsers, setAllUsers] = useState([]);
//   const [orderList, setOrderList] = useState([]);
//   const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  
  useEffect(() => {
    async function fetchOrders() {
        try {
        const storeIds = localStorage.getItem('storeIds');
        const result = await axios.get("gettenantorders/", {
            params: {
                storeIds: storeIds, // Add query parameters here
                sortDesc: "createdAt"
            },
            });
        const record  =  result.data.orders.filter((order) => order.transitStatus && order.transitStatus.toLowerCase() !== "cancelled" && order.transitStatus.toLowerCase() !== "rejected");
        
        const summarized = record.map(order => {
            const paidAmounts = order.manualPayments?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;
            const additionalPayments = order.manualPayments?.reduce((sum, p) => sum + (p.addiPayment || 0), 0) || 0;
            const balance = order.grossTotal - paidAmounts;
            return {
                fullName: order.shippingAddress.name,
                userId: order.shippingAddress.email,
                grossTotal: order.grossTotal,
                grossCount: order.grossCount,
                chassisNumbers: order.chassisNumbers.join(",") || [],
                productName: order.products.map(p => p.name).join(", ") || "",
                paidAmounts,
                additionalPayments,
                balance,
                departureDate: order.departureDate ? dateFormatter2(order.departureDate) : "",
            };
        });
        
    
        const filteredSummarized = summarized.filter(user => user.balance  !== 0);
        const sortedUsers = filteredSummarized.sort((a, b) => b.fullName - a.fullName);

        setRecieved(sortedUsers);
        setAllUsers(sortedUsers);
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    }
    fetchOrders();
  
  }, [])
 

  useEffect(() => {
    try {
      let filteredCustomers = [...allUsers]; 
      
      if (searchTerm && searchTerm !== "") {
        filteredCustomers = filteredCustomers.filter((customer) => {
          // If searchTerm is not a number, filter by name, category, and other conditions
          return (
            customer.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            customer.chassisNumbers?.toLowerCase().includes(searchTerm.toLowerCase()) 
          );
        });
      }
       setRecieved(filteredCustomers);
    }
    catch (error) {
      console.error("Error filtering customers:", error);
      message.error("Failed to filter customers. Please try again later.");
      setRecieved([]);
    }
     
    }, [searchTerm]);

  
  const handleDownloadExcel = () => {
    try {
      if (recieved.length === 0) {
        message.error("No data available to export.");
        return;
      }
                
      const exportData = recieved.map(user => ({
        "Customer Name": user.fullName,
        "Vehicle Details": user.productName,
        "Chassis Numbers": user.chassisNumbers,
        "Received %": user.grossTotal > 0 ? ((user.paidAmounts / user.grossTotal) * 100).toFixed(0) + "%" : "0%",
        "Sold Price": user.grossTotal,
        "Total Received": user.paidAmounts,
        "Balance ": user.balance, 
        "Received Misc": user.additionalPayments,
        "Departure Date": user.departureDate || "",
      }));
    
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

      XLSX.writeFile(workbook, "Customers_Report.xlsx");
    }
    catch (error) {
      console.error("Error downloading Excel:", error);
      message.error("Failed to download Excel. Please try again later.");
    }
  };

  // Helper function

  const columns = [
    {
      title: t?.[l]?.["customer_name"] || "Customer Name",
      dataIndex: "fullName", // can still be used for search/sort
      render: (_, record) => (
        <span>
          {record.fullName}
        </span>
      ),
    }, 
    {
      title: t?.[l]?.["vehicle_details"] || "Vehicle Details",
      dataIndex: "productName", // can still be used for search/sort
      render: (_, record) => (
        <span>
          {record.productName}
        </span>
      ),
    },   
    {
      title: t?.[l]?.["departure_date"] || "Departure Date",
      dataIndex: "departureDate",
      // sorter: (a, b) => a.email.length - b.email.length,
    },
    

    {
      title: t?.[l]?.["chassis_numbers"] || "Chassis Numbers",
      dataIndex: "chassisNumbers",
      // sorter: (a, b) => a.email.length - b.email.length,
    },

    {
      title: t?.[l]?.["recieved"] || "Received %",
      render: (_, record) => {
            const grossTotal = record.grossTotal || 0;
            const totalPaid = record.paidAmounts || 0;
            const percentage = grossTotal > 0 ? (totalPaid / grossTotal) * 100 : 0;
            return `${percentage.toFixed(0)}%`;
        }
      
    },
    {
      title: t?.[l]?.["sold_price"] || "Sold Price",
      dataIndex: "grossTotal",
      render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`
      
    },

    {
      title: t?.[l]?.["total_received"] || "Total Received",
      dataIndex: "paidAmounts",
      render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`
      // sorter: (a, b) => a.email.length - b.email.length,
    },
    {
      title: t?.[l]?.["balance"] || "Balance",
      dataIndex: "balance",
      render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`
      // sorter: (a, b) => a.email.length - b.email.length,
    },
   
    {
      title: t?.[l]?.["recieved_misc"] || "Recieved Misc",
      dataIndex: "additionalPayments",
      render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`
      // sorter: (a, b) => a.email.length - b.email.length,
    },
    
    {
      title: t?.[l]?.["action"] || "Action",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>

               {/* Copy Balance Icon */}
              <Link
                className="me-2 p-2"
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  const name = `${record.fullName || ""}`;
                  const totalBalance = (record.balance ?? 0).toLocaleString();
                 // const miscReceived = (record.miscReceived ?? 0).toLocaleString();
                 // const filteredOrder =  orderList?.filter(item => item?.shippingAddress.email == record?.email);
                  console.log("t[l]?.['message_company']",t[l]?.["message_company"]);
                  const msg = getBalanceMessage2(t[l]?.["message_company"] || "Pak Nippon Corporation, Japan", name, null, totalBalance,record );

                  // const msg = getBalanceMessage(name,totalBalance,record.chassisNumbers);

                  navigator.clipboard.writeText(msg).then(() => {
                    message.success("Message copied to clipboard!");
            
                    Modal.info({
                      title: "Message",
                      content: <pre style={{ whiteSpace: "pre-wrap" }}>{msg}</pre>,
                      okText: "Close",
                      okButtonProps: {
                        style: { backgroundColor: "#BC8F8F", borderColor: "#BC8F8F", color: "#fff" },
                      },
                    });
                  }).catch(() => {
                    message.error("Failed to copy message.");
                  });
                  // navigator.clipboard.writeText(msg).then(() => {
                  //   message.success("Message copied to clipboard!");
                  //   alert(msg);
                  // }).catch(() => {
                  //   message.error("Failed to copy message.");
                  // });
                }}
              >
                <Copy className="feather-copy" />
              </Link>
            
          </div>
        </div>
      ),
      // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  
  //Permissions
  const permissions = useSelector(state => state.permissions) || [];
  const roleTitle = useSelector(state => state.roleTitle) || [];
  const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || [];
  
  // Check permissions
  const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'suppliers' && p.Permission.toLowerCase() === 'view');

  if (!canView) {
      return ( 
      <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
  )}

  return (
    <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
            <h4>{t[l]?.["receivables"] || "Receivables"}</h4>
            <h6>{t[l]?.["manage_receivables"] || "Manage Receivables"}</h6>
            </div>
          </div>

         <div className="search-set" style={{marginLeft: "auto"}}>
            <div className="search-input">
                <input
                    type="text"
                    placeholder={t?.[l]?.["search"] || "Search"}
                    className="form-control"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <span to="#" className="btn btn-searchset" style={{ paddingTop: "10px"}}>
                    <i className="feather-search" />
                </span>
            </div>
            <button className="btn btn-primary" onClick={handleDownloadExcel}>
                {t[l]?.["download_excel"] || "Download Excel"}
            </button>
         </div>
        </div>
                                     
            
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <Table2
                className="table datanew"
                columns={columns}
                dataSource={recieved}
                rowKey={(record) => record._id}
          
              />
            </div>
          </div>
        </div>
       
      </div>
      {/* <ViewCustomerOrders customer={selectedCustomer} orderList={orderList}/> */}
    </div>
  );
};

export default Receivables;
